import React from "react";

function PageLayout({ children }) {
  let leftPanel = null;
  let contentPanel = null;

  React.Children.forEach(children, (child) => {
    if (!React.isValidElement(child)) return;

    if (child.type === PageLayout.LeftPanel) {
      leftPanel = child;
    }

    if (child.type === PageLayout.ContentPanel) {
      contentPanel = child;
    }
  });

  return (
    <div className="relative flex flex-col sm:flex-row bg-background-page sm:overflow-hidden">
      {leftPanel}

      {/* Content wrapper */}
      <div className="flex flex-col flex-1 h-full overflow-hidden">
        {contentPanel}
      </div>
    </div>
  );
}

PageLayout.LeftPanel = function LeftPanel({ children , isSticky = false}) {
 
  return (
    <div className={`sm:flex ${isSticky &&"sticky top-0 z-50 w-full flex-shrink-0 sm:static sm:z-auto sm:w-auto  sm:flex-shrink"}`}>
      {children}
    </div>
    // <>{children}</>
  );
};

PageLayout.ContentPanel = function ContentPanel({ children }) {
  return (
     <> {children}</>
  );
};

export { PageLayout };
